import React, { ReactElement, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  getHourAndMintFromFBTimeStamp,
  getDateAndTimeFromFBTimeStamp,
} from "../../../utils/helpers";

const Agenda = ({ data, idx }): ReactElement => {
  const [response, setIsResponse] = useState<any>({});
  const [sessionList, setSessionList] = useState<any>();

  const { track } = useSelector(({ track }) => ({
    track: track,
  }));

  useEffect(() => {
    setIsResponse(data);
  }, [data]);

  useEffect(() => {
    if (!!track) setSessionList(track.sessions);
  }, [track]);

  return (
    <>
      {!!response && (
        <div className="mt-5" key={idx}>
          <div className="tm__content">
            <div className="tm__content-head d-flex justify-content-between">
              <h2 className="fw-bold m-0">{response.title}</h2>
            </div>
            {!!response.description && (
              <div className="tm__content-body">
                <p
                  dangerouslySetInnerHTML={{
                    __html: response.description,
                  }}></p>
              </div>
            )}
          </div>

          {!!sessionList && (
            <div className="d-flex flex-column">
              {sessionList.map((d) => (
                <div
                  className="tm__list d-flex align-items-center mb-3 p-3"
                  key={d.docId}>
                  <div className="d-flex flex-column flex-md-row flex-1">
                    <div className="d-flex flex-column justify-content-center flex-1 lh-sm">
                      <div className="mb-2 lh-sm">
                        <label className="fs-5 text-primary">{d.name}</label>
                      </div>
                      {!d?.replay?.length && (
                        <div className="d-flex align-items-center">
                          <i className="bi bi-clock-fill fs-8 me-1"></i>
                          <p>
                            {d.startTime &&
                              getDateAndTimeFromFBTimeStamp(
                                d.startTime.seconds
                              )}
                            {" - "}
                            {d.finishTime &&
                              getHourAndMintFromFBTimeStamp(
                                d.finishTime.seconds
                              )}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                  {!!d?.replay?.length && (
                    <div className="flex-shrink-0 ms-3">
                      <a
                        className="btn-icon btn-icon-primary rounded-circle"
                        href={`/replay/${d.docId}`}>
                        <i className="bi bi-play-fill"></i>
                      </a>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Agenda;
